export default __webpack_public_path__ + "static/media/mancity.38983713.png";